import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { STREAM_CONFIG } from '../../constants/streamConfig';
import { StreamDeviceTypes } from './StreamManager';
export function mapStreamsForMerger(streams = {}, configOverrides = {}) {
  const streamsToMerge = [];
  let webcamConfigVariant = 'standaloneWebcam';
  if (streams[StreamDeviceTypes.ScreenSharing]) {
    var _configOverrides$Stre, _configOverrides$Stre2;
    webcamConfigVariant = 'desktopWebcam';
    streamsToMerge.push({
      stream: streams[StreamDeviceTypes.ScreenSharing],
      type: StreamDeviceTypes.ScreenSharing,
      videoConfig: _objectSpread(_objectSpread({}, STREAM_CONFIG.desktop.video), (_configOverrides$Stre = configOverrides[StreamDeviceTypes.ScreenSharing]) === null || _configOverrides$Stre === void 0 ? void 0 : _configOverrides$Stre.video),
      audioConfig: _objectSpread(_objectSpread({}, STREAM_CONFIG.desktop.audio), (_configOverrides$Stre2 = configOverrides[StreamDeviceTypes.ScreenSharing]) === null || _configOverrides$Stre2 === void 0 ? void 0 : _configOverrides$Stre2.audio)
    });
  }
  if (streams[StreamDeviceTypes.Webcam]) {
    var _configOverrides$Stre3, _configOverrides$Stre4;
    streamsToMerge.push({
      stream: streams[StreamDeviceTypes.Webcam],
      type: StreamDeviceTypes.Webcam,
      videoConfig: _objectSpread(_objectSpread({}, STREAM_CONFIG[webcamConfigVariant].video), (_configOverrides$Stre3 = configOverrides[StreamDeviceTypes.Webcam]) === null || _configOverrides$Stre3 === void 0 ? void 0 : _configOverrides$Stre3.video),
      audioConfig: _objectSpread(_objectSpread({}, STREAM_CONFIG[webcamConfigVariant].audio), (_configOverrides$Stre4 = configOverrides[StreamDeviceTypes.Webcam]) === null || _configOverrides$Stre4 === void 0 ? void 0 : _configOverrides$Stre4.audio)
    });
  }
  return streamsToMerge;
}
export function isPermissionDeniedError(error) {
  return error.name === 'NotAllowedError' && error.message === 'Permission denied';
}
export function isPermissionDeniedBySystemError(error) {
  return error.name === 'NotAllowedError' && error.message === 'Permission denied by system';
}
export function isVideoNotReadableError(error) {
  return error.name === 'NotReadableError' && error.message === 'Could not start video source';
}
export function isDeviceNotFoundError(error) {
  return error.name === 'NotFoundError' && (error.message === 'Requested device not found' ||
  // firefox version of non-existent device
  error.message === 'The object can not be found here.');
}